/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('ReportsDigitalSignatureController', reportsDigitalSignatureController)

  reportsDigitalSignatureController.$inject = ['$rootScope', '$http', 'NotificationService', 'simpleObj']

  function reportsDigitalSignatureController ($rootScope, $http, NotificationService, simpleObj) {
    var vm = this
    vm.isB2b = false

    if (simpleObj.reportType === 'digital-signature-b2b') {
      vm.isB2b = true
    }

    vm.filters = {
      startDate: moment().startOf('month').format('DD/MM/YYYY'),
      endDate: moment().format('DD/MM/YYYY')
    }

    vm.dateSelected = function (type, date) {
      if (type === 'from') {
        vm.pkadayEndDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayStartDate.setMaxDate(date)
      }
    }

    vm.downloadProposals = function () {
      if (!validateFields()) {
        return
      }
      let url = apiUrl + '/reports/' + simpleObj.reportType
      $http.get(url, { params: vm.filters })
        .then(function (data) {
          if (!data) {
            NotificationService.errorHandler(data, $rootScope.labels.errorReport)
            return
          }
          const success = prepareFileToDownload(data)
          if (!success) {
            NotificationService.warningHandler(data, $rootScope.labels.noRecord)
          }
        }, function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorReport)
        })
    }

    function prepareFileToDownload (data) {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)
      let blob = new Blob([data], { type: 'text/csv' })

      if (blob.size <= 34) {
        return false
      }

      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: simpleObj.reportType + '.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    function validateFields () {
      var startDate = moment(vm.filters.startDate, 'DD/MM/YYYY')
      var endDate = moment(vm.filters.endDate, 'DD/MM/YYYY')
      if (endDate < startDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate)
        vm.show = false
        return false
      }
      if (endDate.diff(startDate, 'days') > 30) {
        vm.show = false
        NotificationService.warningHandler('', $rootScope.labels.dateMore30Days)
        return false
      }
      return true
    }
  }
// eslint-disable-next-line semi
})();
